import { Button, Grid2, Stack, Typography } from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { IconUserStar } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import AdminsRegister from "../components/AdminsRegister";
import { adminsList } from "../services/admins";
import AdminsTableComponent from "../components/AdminsTableComponent";
import PageHeader from "../components/PageHeader";

const Admins = () => {
  const [open, setOpen] = useState(false);
  const {
    data,
    isLoading,
    isFetching,
    refetch,
  }: {
    data: Array<{
      id: string;
      name: string;
      phone: string;
      createdAt: string | Date;
      status: string;
    }>;
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["adminsList"],
    queryFn: async () => await adminsList({}),
    initialData: [],
  });

  const refetchAll = () => {
    refetch();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Administradores"
          subtitle=" Informações gerais dos administradores."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpen(true)}
              >
                <IconUserStar size={18} />
                <Typography variant="body2">Cadastrar administrador</Typography>
              </Button>
            </Stack>
          }
        />

        <Grid2 size={12}>
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <AdminsTableComponent data={data} refetch={() => refetchAll()} />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <AdminsRegister
        open={open}
        onClose={() => setOpen(false)}
        refetch={() => refetchAll()}
      />
    </ContainerLoading>
  );
};

export default Admins;
